import { LeadHistory } from "../../types"
import { MAP_TYPE_TO_STRING } from "../constants"
import { capitalize } from "./string"

export const convertLeadHistoryTypeToString = (history: LeadHistory) => {
  const { name } = history
  if (!name) return ""
  const valueFromMap = (MAP_TYPE_TO_STRING as any)[name]

  if (!valueFromMap) {
    const typeWithoutUnderscores = name.replace(/_/g, " ")
    return `Activity "${
      typeWithoutUnderscores.charAt(0).toUpperCase() +
      typeWithoutUnderscores.slice(1)
    }"`
  }

  return capitalize(valueFromMap)
}
